<div class="options-expander">
  <hr class="w-full mt-0 mb-0 !border-stroke-01" />
  <div
    #expanderDivElement
    class="options-expander__row"
    (click)="expandedHandler(); analyticsEvent.emit(expanderDivElement)"
    (keypress)="expandedHandler()"
  >
    <span
      [innerHTML]="content"
      tabindex="0"
      class="text-heading text-label-md-medium"
    ></span>
    <span
      class="transition-transform duration-200 ease-out"
      [ngClass]="
        !isExpanded
          ? 'options-expander__row__icon'
          : 'options-expander__row__icon-expanded'
      "
    ></span>
  </div>
</div>
